import cookies from 'js-cookie';
import $ from 'jquery';

$( () => {
    const cookieName = "CONSENTMGR",
        cookieExpire = 60,
        reg_match = /\d+$/,
        $consentPreference = $('#consent_pref_center'),
        $consentPreferenceBox = $('#tiGDPRcpPrefs'),
        $consentBox = $( '#tiGDPRecModal' );

    var gdprCookies = cookies.withConverter({
        read: function (value, name) {
            return decodeURI(value.toString());
        },
        write: function (value, name) {
            return encodeURI(value.toString());
        }
    });

    function defaultCookieData() { 
        //var data={ts:new Date().getTime(),consent:true,c1:1,c2:1,c3:1,c4:1,c5:1,c6:1,c7:1,c8:1,c9:1,c10:1,c11:1,c12:1,c13:1,c14:1,c15:1};   
        var data={ts:new Date().getTime(),consent:true,c1:0,c3:0,c6:0,c7:0};    
        return data;
    }

    function updatedPreferencesValues() {
        var cookieData= getCookieValues();
        $consentPreferenceBox.find('.cookie-custom-checkbox').each ( function() {
            var $input = $(this);
            var inputId = $input.attr('id');            
            let match: RegExpExecArray | null;
            match = reg_match.exec(inputId);
            if (match != null) {
                const catId = match[0];
                cookieData["c" + catId] = $input.is(':checked') ? 1 : 0;
            }
        });
        setCookie(cookieData);        
    }

    function loadPreferencesValues() {
        var cookieData= getCookieValues();
        $consentPreferenceBox.find('.cookie-custom-checkbox').each ( function() {
            const $input = $(this);
            const inputId = $input.attr('id');
            let match: RegExpExecArray | null;
            if(inputId) {
                match = reg_match.exec(inputId)
                if (match != null) {
                    const catId = match[0];
                    if(cookieData["c" + catId] !== "1") {
                        //nothing
                    } else {
                        $input.prop('checked', true);
                    }
                }          
            }
        });
    }

    function acceptAllPreferences() {
        $consentPreferenceBox.find('.cookie-custom-checkbox').each ( function() {
            const $input = $(this);
            $input.prop('checked', true);
        });
    }

    function getDomainName(hostName) {
        return hostName.substring(hostName.lastIndexOf(".", hostName.lastIndexOf(".") - 1));
    }

    function setCookie(cookieData) {
        var mo2Val: string[]= [];
        for(var i in cookieData) {
            mo2Val.push(i + ":" + cookieData[i]);
        }
        var expires=new Date();
        expires.setDate(expires.getDate() + cookieExpire);
        var cookieValue = (mo2Val.join("|"));
        gdprCookies.set( cookieName, cookieValue, {
            domain: getDomainName(window.location.hostname),
            expires,
            path: '/'
        } );        
    }
    

    function refreshCookie() {
        setCookie(getCookieValues());
    }

    function setCookieValue(key,value) {
        var cookieData= getCookieValues();
        cookieData[key]=value;
        setCookie(cookieData);
    }

    function getCookieValues() {
        var values={};
        if(!cookies.get( cookieName )) {
            values = defaultCookieData();
        } else {
            try{
                var cookieData =  gdprCookies.get(cookieName);
                if(cookieData){
                    var i,optOut,optOutData=(cookieData).split("|");
                    for(i=0;i<optOutData.length;i++){
                        optOut=optOutData[i].split(":");
                        values[optOut[0]]=optOut[1];
                    }
                }
            }catch(e){}
        }
        return values;
    }
    
    function loadGACode() {
		if(cookies.get( cookieName )) {
			if(cookies.get( cookieName ).indexOf("c1:1") >= 0) {
                var scripts = document.getElementsByTagName("script")[0];
				var script = document.createElement("script");				
				script.type = "text/javascript",
				script.async = !0,
				script.src = "/App_Themes/v2/js/lestutos/analytics.js",
				scripts.parentNode.insertBefore(script, scripts);
			}
		}
	}

    if (!$consentPreferenceBox.length) return;
    $consentPreference.on("click", e => {
        $consentPreferenceBox.toggle();
        loadPreferencesValues();
    });
    
    $consentPreferenceBox.on( 'click', '#preferences_prompt_submit', e => {
        e.preventDefault();        
        updatedPreferencesValues();
        loadGACode();
        $consentPreferenceBox.hide();
        $consentBox.hide();
        //location.reload();
    } );

    $consentPreferenceBox.on( 'click', '#preferences_prompt_accept', e => {
        e.preventDefault();        
        acceptAllPreferences();
    } );

    $consentPreferenceBox.on( 'click', '.close_btn_thick', e => {
        e.preventDefault();        
        //updatedPreferencesValues();
        $consentPreferenceBox.hide();
    } );
} );
